import { Entitlement } from './entitlement.constants';
import { Authority, emptyUser, User } from './user-entitlement.model';

export class UserEntitlements {
    public readonly user: User;

    private readonly authoritiesByClient: { [id: string]: Authority[] };
    private readonly clientCode: string | undefined;

    constructor(authoritiesByClient: { [clientCode: string]: Authority[] }, user: User) {
        this.authoritiesByClient = authoritiesByClient;
        this.user = user;

        if (!this.hasNoPermissions()) {
            this.clientCode = Object.keys(this.authoritiesByClient)[0];
        }
    }

    hasGlobalEditPartial(): boolean {
        return !this.hasPermissionForClient(this.clientCode, Entitlement.VIEW_AND_EDIT_ALL) &&
            this.hasPermissionForClient(this.clientCode, Entitlement.GLOBAL_EDIT_PARTIAL);
    }

    canUploadCrosstalkAttachments(): boolean {
        return this.hasPermission(Entitlement.ATTACHMENT_EDIT) || this.hasPermission(Entitlement.CROSSTALK_RESTRICTED_ATTACHMENT);
    }

    hasPermission(permission: Entitlement): boolean {
        if (this.hasNoPermissions()) {
            return false;
        }

        return this.hasPermissionForClient(this.clientCode, permission);
    }

    hasNoPermissions(): boolean {
        return !this.authoritiesByClient || !Object.keys(this.authoritiesByClient).length;
    }

    getCostCenter(): string {
        return this.user.costCenterName;
    }

    private hasPermissionForClient(clientCode: string | undefined, permission: string): boolean {
        return !!clientCode && this.authoritiesByClient[clientCode].some((authority: Authority) => authority.authority === permission);
    }
}

export function emptyUserEntitlements(): UserEntitlements {
    return new UserEntitlements({}, emptyUser());
}
